<template>
  <!-- lg:min-h-[164px] -->
  <div class="w-full flex flex-row max-w-[400px] lg:max-w-none  flex-wrap lg:flex-nowrap relative mx-auto">
    <div
      v-if="!noBoxSlot"
      class="lg:w-auto bg-gray-lightest order-1 lg:order-none"
      :class="{ 'hidden lg:block': hideBoxSlot, 'order-4 w-full border-t dark:border-t-0 dark:border-b-1 border-white border-solid lg:border-0': boxBelow, 'w-[calc(100%-190px)]': !boxBelow}"
    >
      <slot name="box" />
    </div>
    <div 
      :class="{ 
        'bg-red': selectedEntity,
        'bg-gray-lightest': !selectedEntity
      }"
      class="w-full  lg:ml-3 flex flex-row order-3 lg:order-none p-5 lg:px-8 lg:py-5 border-t dark:border-t-0 dark:border-b-1 border-white border-solid lg:border-0"
    >
      <slot name="body" />
    </div>
    <div
      v-if="image"
      class="bg-gray-lightest flex flex-row place-items-center order-2 lg:order-none"
      :class="{ 
        'w-full lg:w-[290px]': hideBoxSlot || boxBelow || hasImageSubtitle, 
        'w-[190px] lg:w-[290px]': !hideBoxSlot && !boxBelow && !hasImageSubtitle, 
        'p-5': hasImagePadding,
        'order-4': hasImageSubtitle
      }"
    >
      <div
        v-if="!hasImageSubtitle"
        class="h-full flex w-full place-items-center"
        :class="{ 'p-3': imageContain, 'bg-white': hasImagePadding, 'bg-gray-lightest': !hasImagePadding}"
      >
        <RePictureSet
          v-if="image" 
          :image="image"
          :class="{ 
            'h-full w-full max-h-[195px] lg:w-[290px] lg:h-[164px]': hideBoxSlot|| boxBelow, 
            ' w-[190px] h-[107px] lg:w-[290px] lg:h-[164px]': (!hideBoxSlot && !boxBelow) || hasImageSubtitle
          }"
          :image-class="'lazyload object-center h-full ' + (imageContain ? 'object-contain ' : 'object-cover ') + ((hideBoxSlot|| boxBelow) ? 'max-h-[195px]  lg:min-h-[135px] ': 'min-h-[106px] ')"
          sizes="280px"
        />
      </div>
      <div
        v-else
        class="h-full flex w-full lg:w-[290px] flex-col place-items-center"
      >
        <RePictureSet
          v-if="image" 
          :image="image"
          class="w-full"
          :image-class="'lazyload object-center w-full lg:w-[290px] lg:h-[164px] object-contain'"
          sizes="180px"
        />
        <div
          v-if="hasImageSubtitle"
          class="text-center text-sm w-full"
        >
          <span v-html="imageSubtitle" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RePictureSet from '~/components/rxt/recomponent/RePictureSet.vue'
export default {
  components: {
    RePictureSet
  },
  props: {
    image: {
      type: Object
    },
    imageContain: {
      type: Boolean,
      default: false
    },
    hideBoxSlot: {
      type: Boolean,
      default: false
    },
    noBoxSlot: {
      type: Boolean,
      default: false
    },
    hasImagePadding: {
      type: Boolean,
      default: false
    },
    hasImageSubtitle: {
      type: Boolean,
      default: false
    },
    imageSubtitle: {
      type: String
    },
    boxBelow: {
      type: Boolean,
      default: false
    },
    selectedEntity: {
      type: Boolean,
      default: false
    }
  }
}
</script>